import React from 'react';

const Colaboradores = () => {
  return (
    <div>
      <h1>Leads</h1>
    </div>
  );
}

export default Colaboradores;
